var $eccab2b0118aef08$exports = {};
$eccab2b0118aef08$exports = {
  "colorInputLabel": function colorInputLabel(args) {
    return "".concat(args.label, ", ").concat(args.channelLabel);
  },
  "colorNameAndValue": function colorNameAndValue(args) {
    return "".concat(args.name, ": ").concat(args.value);
  },
  "colorPicker": "\u0623\u062F\u0627\u0629 \u0627\u0646\u062A\u0642\u0627\u0621 \u0627\u0644\u0644\u0648\u0646",
  "colorSwatch": "\u062A\u063A\u064A\u064A\u0631 \u0627\u0644\u0623\u0644\u0648\u0627\u0646",
  "transparent": "\u0634\u0641\u0627\u0641",
  "twoDimensionalSlider": "\u0645\u064F\u0646\u0632\u0644\u0642 2D"
};
export { $eccab2b0118aef08$exports as default };